/** Las fotos que vienen incluidas con la app se sirven en WebP.
 *
 *  Estaban como PNG de 480×480 con transparencia, ~370 KB cada una, para
 *  dibujarse a 72 px en el listado de Inventario y a 112 px como máximo
 *  en la ficha del producto. Eso son 6 MB que el navegador baja y, peor,
 *  decodifica y reescala en cada pintado —justo lo que se sentía como
 *  scroll "a tirones". En WebP a 320 px (el doble de lo que pide una
 *  pantalla Retina) las mismas 16 fotos pesan 460 KB: 13 veces menos.
 *
 *  La traducción se hace acá, al dibujar, y no migrando la base: las
 *  filas de `productos` que ya están en Supabase siguen apuntando al
 *  `.png`, y así no hay que tocar datos de producción para que se vean
 *  bien. Una foto subida por alguien del equipo (Supabase Storage,
 *  `data:`, `blob:`) no coincide con el patrón y pasa intacta. */
export function fotoApp(ruta: string | undefined): string | undefined {
  if (!ruta) return ruta
  if (!ruta.startsWith('/productos/') || !ruta.endsWith('.png')) return ruta
  return `${ruta.slice(0, -'.png'.length)}.webp`
}
